import React, { useState, useEffect } from 'react'
import '../../Styles/App.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCircleArrowRight, faXmark, faPlus } from '@fortawesome/free-solid-svg-icons';
import toast from 'react-hot-toast';
import axios from 'axios';
import { SERVER_URL } from '../../../config';
import { href, useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";


export default function Section1({ showSlides, OpenClubModal }) {
  console.log(OpenClubModal)
  const [isOpen, setIsOpen] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isDnaPopupOpen, setIsDnaPopupOpen] = useState(false);

  const dnaStatus = {
    registrationCompleted: true,
    processInitiated: true,
    fileUploaded: true,
    analysisStarted: true,
    reportGenerated: true,
  };

  const steps = [
    { key: "registrationCompleted", label: "Registration Completed" },
    { key: "processInitiated", label: "DNA Process Initiated" },
    { key: "fileUploaded", label: "File Uploaded" },
    { key: "analysisStarted", label: "Analysis Started" },
    { key: "reportGenerated", label: "Report Generated" },
  ];

  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const source = queryParams.get('source');
  const [matchPlayed, setMatchPlayed] = useState('');
  const [goals, setGoals] = useState('');
  const [tackles, setTackles] = useState('');
  const [assist, setAssist] = useState('');
  const [saves, setSaves] = useState('');
  const [clubStatus, setClubStatus] = useState('');
  const [club, setClub] = useState('');
  const [clubName, setClubName] = useState('');

  const [clubNames, setClubNames] = useState([]);
  const [email, setEmail] = useState('');

  const [isActivetab, setActivetab] = useState('div1')

  const handleActivetoggle = (tab) => {
    setActivetab(tab)
  }

  useEffect(() => {
    get_club_names();
  }, []);

  const get_club_names = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/api/v2/get-club-names`);
      if (response.data.status === true) {
        setClubNames(response.data.data);
      } else {
        setClubNames([])
      }
    } catch (error) {
      console.error("Error checking the club names : ", error);
    }
  }

  const playerToken = sessionStorage.getItem('player_token');

  useEffect(() => {
    const isValid = (token) => {
      if (!token) return false;
      try {
        let decoded = jwtDecode(token);
        setEmail(decoded.email);
      } catch (error) {
        console.error("Error decoding token : ", error)
        setEmail('');
      }
    };

    isValid(playerToken)
  }, [playerToken]);
  const token = sessionStorage.getItem('player_token');
  const clubtoken = sessionStorage.getItem('club_token');

  const checkTokenValidity = (tokenKey) => {

    if (!token) return null;
    try {
      const decoded = jwtDecode(token);
      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp < currentTime) {
        sessionStorage.removeItem("player_token");
        sessionStorage.removeItem("club_token");
        return null;
      }
      return decoded.email;
    } catch (error) {
      return null;
    }
  };
  useEffect(() => {
    const userEmail = checkTokenValidity("player_token") || checkTokenValidity("club_token");
    setEmail(userEmail);

    check_DNA_register()

  }, []);
  const check_DNA_register = async () => {
    try {

      const alreadySeen = localStorage.getItem("dna_popup_shown");
      if (alreadySeen === "true") return;

      const response = await axios.get(`${SERVER_URL}/api/v2/player-profile-dna`, {
        headers: { Authorization: `Bearer ${token}`, }
      });
      console.log(response);

      if (response.data.status === true && response.data.msg === "completed") {
        setIsDnaPopupOpen(true);
        localStorage.setItem("dna_popup_shown", "true");
      }

      if (response.data.status === true && response.data.msg === 'registered') {
        setIsOpen1(true);
        localStorage.setItem("dna_popup_shown", "true");
      } else if (response.data.status === true && response.data.msg === 'not registered') {
        setIsOpen(true);
      }
    } catch (error) {
      console.error("Error checking the player dna registration : ", error);

    }
  }


  const handleSubmit = async () => {
    try {
      let data = {
        "Match Played": matchPlayed,
        "Goals": goals,
        "Tackles": tackles,
        "Assist": assist,
        "Saves": saves,
        "ClubStatus": clubStatus,
        "Club": clubName.trim(),
      };

      const missingFields = [];
      const invalidFields = [];

      for (const key in data) {
        if (key === "Club" && data["ClubStatus"] === true && clubNames?.length > 0) {
          if (!data[key]) missingFields.push("Club");
        } else if (key !== "ClubStatus" && key !== "Club" && (data[key] === "" || data[key] == null)) {
          missingFields.push(key);
        }
      }

      if (missingFields.length > 0) {
        toast.error(`Please fill in the required fields: ${missingFields.join(", ")}`);
        return;
      }

      const numericFields = ["Match Played", "Goals", "Tackles", "Assist", "Saves"];
      numericFields.forEach((field) => {
        if (data[field] !== "" && isNaN(Number(data[field]))) {
          invalidFields.push(field);
        }
      });

      if (invalidFields.length > 0) {
        toast.error(`Invalid input: ${invalidFields.join(", ")} must be a number.`);
        return;
      }

      const updateData = {
        matchPlayed: Number(matchPlayed.trim()),
        goals: Number(goals.trim()),
        tackles: Number(tackles.trim()),
        assist: Number(assist.trim()),
        saves: Number(saves.trim()),
        club: clubName.trim(),
      };
      const response = await axios.post(`${SERVER_URL}/api/v2/player-profile-update`, updateData, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('player_token')}`, }
      });

      if (response.data.status === true) {
        toast.success("Profile updated successfully!");
        setTimeout(() => {
          setIsOpen1(false);
          setIsOpen2(true);
        }, 1500);
      } else {
        toast.error(response.data.msg || "Failed to update profile. Please try again.");
      }
    } catch (error) {
      console.error("Failed to update player details:", error);

      if (error?.response?.status === 403) {
        toast.error(`${error?.response?.data?.error?.msg}`);
        setTimeout(() => {
          toast.dismiss();
          navigate("/player/Login");
        }, 1500);
      } else {
        toast.error(error?.response?.data?.msg || "Something went wrong. Please try again.");
      }
    }
  };

  return (
    <div className='min-h-screen flex items-center justify-center bg-[#0E081B]/30'>
      <div className='w-[90%] relative'>
        <div className='flex justify-center'>
          <button className='px-10 py-2 rounded-full font-bold flex items-center gap-2 welcome-neon'><img src='/assets/icon/sparkle.svg'></img> <span>Welcome to the beta version</span></button>
        </div>
        <div className='relative'>
          <h1 className='mt-5 text-center text-3xl lg:text-4xl 2xl:text-5xl font-medium '>From Genome to Glory:<br className='hidden md:block' /><span className='text-xl'> Scientific Skill Assessment | Precision Coaching | Fan-Powered Engagement</span></h1>
          <p className='capitalize text-center mt-3'>"GoalDex connects players, clubs, and fans by merging advanced data insights with blockchain, <br className='hidden md:block' /> driving personalized development and future-focused soccer engagement."</p>
        </div>
        <div className='flex justify-center gap-10 mt-5'>
          <button className='px-5 py-2 rounded-full border-2 font-bold flex items-center gap-2 cursor-pointer' onClick={() => navigate("/player/signup")} style={{ zIndex: 1 }}><span>SIGN UP </span><img src='/assets/icon/magic.svg'></img></button>
          <button className='px-10 py-2 rounded-full bg-white text-black font-bold cursor-pointer' onClick={() => navigate("/player/Login")} style={{ zIndex: 1 }}>LOGIN</button>
        </div>
        <div className='flex items-center justify-center translate-x-2 lg:translate-x-0'>
          <div className='flex justify-between w-[100%] mt-10'>
            <div className='flex flex-col gap-8'>
              <div className='flex flex-col gap-2 items-center'>
                <div className='Benefits-points border-[2px] border-[#5C1FE2] p-[2px] rounded-xl relative overflow-hidden'>
                  <div className='conic-gradient-background'></div>
                  <div className='grid place-content-center h-14 w-14 bg-[#15101c] backdrop-blur-sm rounded-lg relative z-10'>
                    <img src='/assets/icon/shield.svg' alt='Shield Icon' />
                  </div>
                </div>
                <h1 className='font-bold text-sm text-center'>Blockchain-Verified</h1>
              </div>
              <div className='flex flex-col gap-2 items-center'>
                <div className='Benefits-points border-[2px] border-[#5C1FE2] p-[2px] rounded-xl relative overflow-hidden'>
                  <div className='conic-gradient-background'></div>
                  <div className='grid place-content-center h-14 w-14 bg-[#15101c] backdrop-blur-sm rounded-lg relative z-10'>
                    <img src='/assets/icon/access.svg' alt='Access Icon' />
                  </div>
                </div>
                <h1 className='font-bold text-sm text-center'>Club & Player Centric </h1>
              </div>
            </div>
            <div className='flex items-center justify-center translate-x-3 lg:translate-x-5'>
              <img src='/assets/others/Ball.svg' className='w-[70%] lg:w-auto ball-spin' style={{ zIndex: 1 }} />
              <div className='w-[150px] h-[150px] bg-[#5C1FE2]/70 blur-xl absolute rounded-full'></div>
            </div>
            <div className='flex flex-col gap-8'>
              <div className='flex flex-col gap-2 items-center'>
                <div className='Benefits-points border-[2px] border-[#5C1FE2] p-[2px] rounded-xl relative overflow-hidden'>
                  <div className='conic-gradient-background'></div>
                  <div className='grid place-content-center h-14 w-14 bg-[#15101c] backdrop-blur-sm rounded-lg relative z-10'>
                    <img src='/assets/icon/hand.svg' alt='Hand Icon' />
                  </div>
                </div>
                <h1 className='font-bold text-sm text-center'>Genetically-<br className='block lg:hidden' />Informed</h1>
              </div>
              <div className='flex flex-col gap-2 items-center'>
                <div className='Benefits-points border-[2px] border-[#5C1FE2] p-[2px] rounded-xl relative overflow-hidden'>
                  <div className='conic-gradient-background'></div>
                  <div className='grid place-content-center h-14 w-14 bg-[#15101c] backdrop-blur-sm rounded-lg relative z-10'>
                    <img src='/assets/icon/people.svg' alt='People Icon' />
                  </div>
                </div>
                <h1 className='font-bold text-sm text-center'>Fan Engagement Ecosystem</h1>
              </div>
            </div>
          </div>
          <img src='/assets/bg/section2app.svg' className='absolute w-[80%]'></img>
        </div>
      </div>
      {/*       
      <div>
        {isOpen && (
          <div className="fixed inset-0 flex items-center h-full  justify-center bg-[#000]/70 z-50  px-2 py-5 overflow-auto ">
            <div className="bg-[#232323]/95 p-2 lg:p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg gap-5 flex flex-col lg:flex-row justify-center absolute top-[12%] ">
              <div className='lg:w-[50%]  px-2'>
                <div className='flex justify-center'>
                  <img className='w-7/12' src='/assets/others/Goal-popup.svg'></img>
                </div>
              </div>
              <div className='lg:w-[50%] px-2'>
                <div>
                  <h1 className='text-[#fff] text-xl font-bold'>Welcome On Board</h1>
                </div>
                <div className='mt-2'>
                  <h3 className='text-[#fff] text-xs'>Leading the way in blockchain innovation, we are redefining how the world connects, secures, and transacts, bringing a new era of decentralized technology into soccer.</h3>
                </div>
                <div className='mt-2'>
                  <div className='flex flex-col gap-1 px-4'>
                    <div className='w-[1px] h-4 border border-white'></div>

                  </div>
                  <div className='flex justify-start gap-5 items-center'>
                    <img src='/assets/others/small-ball.svg'></img>
                    <p className='text-lg font-bold text-[#20FF5F]'>Registration</p>
                  </div>
                  <div className='flex flex-col gap-1 px-4'>
                    <div className='w-[1px] h-4 border border-white'></div>
                    <div className='w-[1px] h-4 border border-white'></div>
                    <div className='w-[1px] h-4 border border-white'></div>

                  </div>
                  <div className='flex justify-start gap-5 items-center'>
                    <img src='/assets/others/small-ball.svg'></img>
                    <p className='text-lg  text-[#fff]'>Profile Update</p>
                  </div>
                  <div className='flex flex-col gap-1 px-4'>
                    <div className='w-[1px] h-4 border border-white'></div>
                    <div className='w-[1px] h-4 border border-white'></div>
                    <div className='w-[1px] h-4 border border-white'></div>

                  </div>
                  <div className='flex justify-start gap-5 items-center'>
                    <img src='/assets/others/small-ball.svg'></img>
                    <p className='text-lg  text-[#fff]'> DNA Kit registration</p>
                  </div>
                  <div className='flex flex-col gap-1 px-4'>
                    <div className='w-[1px] h-4 border border-white'></div>
                    <div className='w-[1px] h-4 border border-white'></div>


                  </div>
                </div>

                <div className='flex justify-center lg:justify-end items-center'>

                  <button
                    className='flex bg-transparent rounded-full px-2 items-center py-[1px] text-[#fff] text-xs 2xl:text-base border border-white font-bold duration-300 cursor-pointer'
                    onClick={() => {
                      setIsOpen1(true)
                      setIsOpen(false)
                    }}
                  >
                    Proceed <FontAwesomeIcon icon={faCircleArrowRight} className='text-xl translate-x-1' />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {isOpen1 && (
          <div className="fixed inset-0 flex items-center h-full  justify-center bg-[#000]/70 z-50  px-2 py-5 overflow-auto ">
            <div className="bg-[#232323]/95 p-2 lg:p-6 w-[90%] lg:w-[70%] rounded-xl shadow-lg gap-5 flex flex-col lg:flex-row justify-center absolute top-[12%] ">
              <div className='lg:w-[50%]  px-2'>
                <div className='flex justify-center'>
                  <img className='w-7/12' src='/assets/others/Goal-popup.svg'></img>
                </div>
              </div>
              <div className='lg:w-[50%] px-2 flex flex-col gap-5'>
                <div>
                  <h1 className='text-[#fff] text-xl font-bold'>Profile Update</h1>
                </div>
                <div className='mt-3 flex flex-col gap-2'>
                  <p className='text-white text-xm'>Number of Matches Played</p>
                  <input onChange={(e) => { setMatchPlayed(e.target.value); }} className='w-full border border-white rounded-sm text-white bg-[#2b2b2c] px-2 outline-none'></input>
                </div>
                <div className='mt-3 flex flex-col gap-2'>
                  <p className='text-white text-xm'>Stats Update</p>
                  <div className='w-[88%] flex justify-between gap-4'>
                    <p className='flex flex-col  gap-0 border border-white w-[25%] bg-[#2b2b2c] rounded-sm'><input onChange={(e) => { setGoals(e.target.value) }} className='text-center translate-y-5 rounded-sm text-white  px-2 outline-none'></input>&nbsp;<span className='text-white text-center rounded-sm bg-[#545454] border-t border-white'>Goals</span></p>
                    <p className='flex flex-col  gap-0 border border-white w-[25%] bg-[#2b2b2c] rounded-sm'><input onChange={(e) => { setTackles(e.target.value) }} className='text-center translate-y-5 rounded-sm text-white  px-2 outline-none'></input>&nbsp;<span className='text-white text-center rounded-sm bg-[#545454] border-t border-white'>Tackles</span></p>
                    <p className='flex flex-col  gap-0 border border-white w-[25%] bg-[#2b2b2c] rounded-sm'><input onChange={(e) => { setAssist(e.target.value) }} className='text-center translate-y-5 rounded-sm text-white  px-2 outline-none'></input>&nbsp;<span className='text-white text-center rounded-sm bg-[#545454] border-t border-white'>Assist</span></p>
                    <p className='flex flex-col  gap-0 border border-white w-[25%] bg-[#2b2b2c] rounded-sm'><input onChange={(e) => { setSaves(e.target.value) }} className='text-center translate-y-5 rounded-sm text-white  px-2 outline-none'></input>&nbsp;<span className='text-white text-center rounded-sm bg-[#545454] border-t border-white'>Saves</span></p>
                  </div>
                </div>
                <div>
                  <div className='mt-3 flex items-center gap-4'>
                    <p className='flex items-center gap-2 text-xm text-white'>
                      <input
                        type='checkbox'
                        onChange={(e) => { setClubStatus(e.target.checked); setClub(''); setClubName('') }}
                        checked={clubStatus}
                        className='cursor-pointer'
                      />
                      Are you already part of a club?
                    </p>
                  </div>

                  {clubStatus && (
                    <div className='mt-2'>
                      <p className='text-white text-xm'>If yes, select a club:</p>
                      <select
                        onChange={(e) => { setClub(e.target.value); setClubName(e.target.value) }}
                        className="w-full mt-2 border border-white rounded-sm text-white bg-[#2b2b2c] px-2 py-1 outline-none cursor-pointer"
                        disabled={clubNames.length === 0}
                      >
                        {clubNames.length > 0 ? (
                          <>
                            <option value="">Select a club</option>
                            {clubNames.map((club, index) => (
                              <option key={index} value={club}>
                                {club}
                              </option>
                            ))}
                            <option key='others' value='others'>others</option>
                          </>
                        ) : (
                          <option value="">No clubs available</option>
                        )}
                      </select>
                    </div>
                  )}
                  {club === 'others' ?
                    (<div className='mt-4 flex flex-col gap-1'>
                      <p className='text-white text-xm'>Club Name</p>
                      <input onChange={(e) => { setClubName(e.target.value) }} className='w-full border border-white rounded-sm text-white bg-[#2b2b2c] px-2 outline-none'></input>
                    </div>) : ''
                  }
                </div>



                <div className='flex justify-center  items-center mt-3'>
                  <button
                    className='flex bg-transparent rounded-full px-2 items-center py-[1px] text-[#fff] text-xs 2xl:text-base border border-white font-bold duration-300 cursor-pointer'
                    onClick={() => { handleSubmit() }}
                  >
                    Update <FontAwesomeIcon icon={faCircleArrowRight} className='text-xl translate-x-1' />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      */}
      <div>
        {isOpen && (
          <div className="fixed inset-0 flex items-center h-full  justify-center bg-[#000]/70 z-40  px-2 py-5 overflow-auto ">
            <div className="bg-[#232323]/95 p-2 lg:p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg  absolute top-[12%] ">
              <div>
                <h1 className='text-[#fff] text-xl font-bold text-center'>Congratulation </h1>
                {/* <p className='text-white text-center text-sm mt-4'>You NFT minted successfully</p> */}
                <p className='text-white text-center text-sm mt-4'>Your profile updated successfully</p>

                <div className='flex justify-center'>
                  <img className='w-3/12' src='/assets/others/Gaol-popup2.svg'></img>
                </div>
                <p className='text-white text-center text-sm '>Analyze and upskill your ability through the genetic validation</p>
                <div className='flex justify-center gap-10 items-center mt-5'>

                  <button onClick={() => { navigate('/my-dna') }}
                    className='flex bg-transparent rounded-full px-2 items-center py-[1px] text-[#fff] text-xs 2xl:text-base border border-white font-bold duration-300 cursor-pointer'
                  >
                    Check Out <FontAwesomeIcon icon={faCircleArrowRight} className='text-xl translate-x-1' />
                  </button>
                  {/*<button onClick={() => { setIsOpen(false); setIsOpen1(false); setIsOpen2(false); }} className='italic cursor-pointer'>Skip for now</button>*/}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div>
        {isOpen1 && (
          <div className="fixed inset-0 md:flex md:items-center h-full  md:justify-center bg-[#000]/70 z-40 px-2 py-5 overflow-auto ">
            <div className="bg-[#232323]/95 p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg mx-auto relative lg:absolute lg:top-[12%] ">
              <div className='block md:hidden'><FontAwesomeIcon icon={faXmark} onClick={() => { setIsOpen3(false) }} className='absolute right-3 top-3' /></div>
              <div>
                <h1 className='text-[#fff] text-xl font-bold text-center'>Minting in Progress</h1>
                <p className='text-white text-center text-sm mt-4'>Your DNA analysis process has been initiated. Please check your email regularly for updates. Once your report is generated, your passport will be created accordingly.</p>
                <div className='flex flex-col md:flex-row gap-10 items-center mt-5'>
                  <div className='w-[100%] lg:w-[50%] 2xl:text-lg space-y-5'>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                              ${isActivetab === 'div1' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                      onClick={() => handleActivetoggle('div1')}>
                      <p className='flex items-center gap-5'><span>01</span> Muscular System</p>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                              ${isActivetab === 'div2' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                      onClick={() => handleActivetoggle('div2')}>
                      <p className='flex items-center gap-5'><span>02</span> Psychiatrics</p>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                              ${isActivetab === 'div3' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                      onClick={() => handleActivetoggle('div3')}>
                      <p className='flex items-center gap-5'><span>03</span> Sports</p>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                              ${isActivetab === 'div4' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                      onClick={() => handleActivetoggle('div4')}>
                      <p className='flex items-center gap-5'><span>04</span> Injuries</p>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                    <div className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 duration-500 flex items-center justify-between cursor-pointer
                                              ${isActivetab === 'div5' ? 'font-bold w-[100%] bg-black border-[#AB11ED]' : 'w-[80%] brightness-50'}`}
                      onClick={() => handleActivetoggle('div5')}>
                      <p className='flex items-center gap-5'><span>05</span> Behavior</p>
                      <FontAwesomeIcon icon={faArrowRight} />
                    </div>
                  </div>
                  <div className='w-[100%] lg:w-[50%]'>
                    {isActivetab === 'div1' && (
                      <div><img src='/assets/map/chart1.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div2' && (
                      <div><img src='/assets/map/chart2.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div3' && (
                      <div><img src='/assets/map/chart3.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div4' && (
                      <div><img src='/assets/map/chart4.svg' className='mx-auto'></img></div>
                    )}
                    {isActivetab === 'div5' && (
                      <div><img src='/assets/map/chart5.svg' className='mx-auto'></img></div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {isDnaPopupOpen && (
          <div className="fixed inset-0 md:flex md:items-center h-full md:justify-center bg-[#000]/70 z-40 px-2 py-5 overflow-auto">
            <div className="bg-[#232323]/95 p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg mx-auto relative lg:absolute lg:top-[12%]">

              {/* Close on Mobile */}
              <div className="block md:hidden">
                <FontAwesomeIcon
                  icon={faXmark}
                  onClick={() => setIsDnaPopupOpen(false)}
                  className="absolute right-3 top-3 cursor-pointer text-white"
                />
              </div>

              <div>
                <h1 className="text-[#fff] text-xl font-bold text-center">DNA Status Tracker</h1>
                <p className="text-white text-center text-sm mt-4">
                  Here is the current progress of the player's DNA registration and analysis.
                </p>

                <div className="flex flex-col md:flex-row gap-10 items-center mt-5">

                  {/* LEFT: Dynamic Status Steps */}
                  <div className="w-[100%] lg:w-[50%] 2xl:text-lg space-y-5">

                    {steps.map((step, i) => {
                      const allPrevDone = steps.slice(0, i).every(s => dnaStatus[s.key]);
                      const isCurrent = !dnaStatus[step.key] && allPrevDone;
                      const isDone = dnaStatus[step.key];
                      const status = isDone ? "done" : isCurrent ? "active" : "pending";

                      return (
                        <div
                          key={i}
                          className={`rounded-full border py-3 px-5 2xl:py-5 2xl:px-10 flex items-center justify-between transition-all duration-300
                    ${status === "done" ? "bg-black border-[#AB11ED] font-bold"
                              : status === "active" ? "bg-black border-yellow-500 font-bold animate-pulse"
                                : "w-[80%] brightness-50"}`}
                        >
                          <p className="flex items-center gap-5">
                            <span>
                              {status === "done" ? "✔" : status === "active" ? "⏳" : "…"}
                            </span>
                            {step.label}
                          </p>
                        </div>
                      );
                    })}
                  </div>

                  {/* RIGHT: Static or Dynamic Image */}
                  <div className="w-[100%] lg:w-[50%]">
                    <img
                      src="/assets/map/chart1.svg"
                      className="mx-auto"
                      alt="DNA Chart Preview"
                    />
                  </div>
                </div>

                {/* Redirect Button */}
                <div className="flex justify-center mt-8">
                  <button
                    onClick={() => navigate('/user/dashboard')}
                    className="bg-black text-white px-6 py-3 rounded-full border border-[#AB11ED] hover:brightness-110 transition"
                  >
                    View Full Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

      </div>
      <div>
        {OpenClubModal && (
          <div className="fixed inset-0 md:flex md:items-center h-full  md:justify-center bg-[#000]/70 z-40 px-2 py-5 overflow-auto ">
            <div className="bg-[#232323]/95 p-6 w-[90%] lg:w-[60%] rounded-xl shadow-lg mx-auto relative">
              <div className='block md:hidden'><FontAwesomeIcon icon={faXmark} onClick={() => { setIsOpen3(false) }} className='absolute right-3 top-3' /></div>
              <div>
                <h1 className='text-[#fff] text-xl font-bold text-center'>Ready to Onboard your Players</h1>
                <p className='text-white text-center text-sm mt-4'>Your DNA analysis process has been initiated. Please check your email regularly for updates. Once your report is generated, your passport will be created accordingly.</p>
                <div className='flex flex-col md:flex-row gap-10 items-center'>
                  <div className='w-[100%] lg:w-[50%]'>
                    <div className='h-[275px] 2xl:h-[400px] object-cover'><img src='/assets/others/clubsignup.svg' className='mx-auto h-full'></img></div>
                  </div>
                  <div className='w-[100%] lg:w-[50%]'>
                    <label className='font-semibold text-lg'>Enter your player Unique ID</label>
                    <input className='w-[100%] bg-[#545454] mt-1 border rounded outline-none py-2 px-3'></input>
                    <button className='flex items-center mt-3 gap-2 cursor-pointer'>
                      <div className='w-7 h-7 rounded-full bg-white text-black grid place-content-center'><FontAwesomeIcon icon={faPlus} /></div> Add Now</button>
                  </div>
                </div>
                <div className='flex justify-center'>
                  <button onClick={() => { navigate('/my-dna') }}
                    className='flex bg-transparent rounded-full px-2 items-center py-[1px] text-[#fff] text-xs 2xl:text-base border border-white font-bold duration-300 cursor-pointer'
                  >
                    Proceed to dashboard  <FontAwesomeIcon icon={faCircleArrowRight} className='text-xl translate-x-1' />
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}